export enum PasswordErrorCode {
  OLD_PASSWORD_INVALID = 'OLD_PASSWORD_INVALID',
  PASSWORD_CONFIRMATION_FAILED = 'PASSWORD_CONFIRMATION_FAILED',
  PASSWORD_HISTORY_REUSE = 'PASSWORD_HISTORY_REUSE',
  PASSWORD_REQUIRES_LETTER = 'PASSWORD_REQUIRES_LETTER',
  PASSWORD_REQUIRES_MIXED_CASE = 'PASSWORD_REQUIRES_MIXED_CASE',
  PASSWORD_REQUIRES_NUMBERS = 'PASSWORD_REQUIRES_NUMBERS',
  PASSWORD_REQUIRES_SYMBOLS = 'PASSWORD_REQUIRES_SYMBOLS',
}
